
import { useDashboardStore } from '@/store/dashboard'
import { defineComponent } from 'vue'
import dayjs from 'dayjs'
import BaseButton from '@/components/BaseButton.vue'
import { useRouter } from 'vue-router'

export default defineComponent({
  components: { BaseButton },
  name: 'dashboard',
  setup() {
    const store = useDashboardStore()
    const router = useRouter()

    store.fetchQuizes()

    function createQuiz() {
      router.push('/create-quiz')
    }

    return { store, dayjs, createQuiz }
  },
})
